<template>
	<div>
		<h2>All Done!</h2>
		<p class="explanation">Please wait while your settings are being applied.</p>
	</div>
</template>